/**
 * FEAT-013 — LLM provider preference, SPA side.
 *
 * Mirrors the slugs in apps/api/src/pipeline/providers/provider-registry.ts and
 * the api_keys provider CHECK. Used by the publication + workspace preference
 * dropdowns and the no-key warning. Keep in lockstep with the API list.
 */

export interface ProviderOption {
  value: string;
  label: string;
}

/** LLM providers selectable as an editorial preference, in display order. */
export const LLM_PROVIDERS: ProviderOption[] = [
  { value: "anthropic", label: "Anthropic (Claude)" },
  { value: "openai", label: "OpenAI (GPT)" },
  { value: "gemini", label: "Google Gemini" },
  { value: "xai", label: "xAI (Grok)" },
  { value: "zhipu", label: "Zhipu (GLM)" },
  { value: "qwen", label: "Qwen (Alibaba)" },
  { value: "deepseek", label: "DeepSeek" },
  { value: "mistral", label: "Mistral" },
];

export function providerLabel(slug: string | null | undefined): string {
  if (!slug) return "Default";
  return LLM_PROVIDERS.find((p) => p.value === slug)?.label ?? slug;
}

/** Shape of one GET /api-keys row that matters for the no-key check. */
export interface ApiKeyLike {
  provider: string;
  status?: string;
}

/** True when an active key exists for the provider at any visible scope. */
export function hasActiveKeyFor(
  keys: ApiKeyLike[] | undefined,
  provider: string | null | undefined
): boolean {
  if (!provider || !keys) return true; // no preference → nothing to warn about
  return keys.some((k) => k.provider === provider && k.status === "active");
}
